import secretaryApron from '../img/home/thumb_Provincial Grand Secretary Apron_1024.jpeg'
import keyStone from '../img/home/thumb_Keystone Jewel_1024.jpeg'
import markMastersApron from '../img/home/thumb_Masters Mark Apron_1024.jpeg'
import pgm from '../img/home/R.W.Bro Andrew Lee.jpg'
import Markdown from "markdown-to-jsx";

import welcomeFile from '../markdown/home/welcome.md'
import {useEffect, useState} from "react";


function HomePage() {

    const [welcome, setWelcome] = useState('')

    useEffect(() => {
        fetch(welcomeFile)
            .then((res) => res.text())
            .then(value => setWelcome(value))
            .catch(reason => console.log(reason))
    })

    return (
        <>
            <section className="section">
                <div className="columns is-centered">
                    <div className="column is-two-thirds has-text-centered">
                        <h2 className="title">Square Talk Podcast: the Mark and Royal Ark Mariner Degrees</h2>
                        <p className="subtitle">A Masonry degree that leaves you smiling</p>
                        <figure className="image is-16by9">
                            <iframe
                                className="has-ratio"
                                src="https://www.youtube-nocookie.com/embed/tI1CcgNKoUI"
                                title="A Masonry degree that leaves you smiling"
                                frameBorder="0"
                                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                            />
                        </figure>
                        <p className="mt-3">
                            <a href="https://www.youtube.com/watch?v=tI1CcgNKoUI" target="_blank" rel="noopener noreferrer">
                                Watch on YouTube
                            </a>
                        </p>
                    </div>
                </div>
            </section>

            <section className="section">
                <div className="columns">
                    <div className="column is-one-third">
                        <img src={secretaryApron} alt="Secretary Apron"/>
                    </div>
                    <div className="column is-one-third">
                        <img src={keyStone} alt="Keystone Jewel"/>
                    </div>
                    <div className="column is-one-third">
                        <img src={markMastersApron} alt="Mark Masters Apron"/>
                    </div>
                </div>
            </section>

            <section className="section">
                <div className="columns">
                    <div className="column has-text-centered">
                        <h2 className="title">Welcome from the Provincial Grand Master</h2>
                        <div className="columns  has-text-left">
                            <div className="column is-one-third">
                                <img src={pgm} alt="Provincial Grand Master"/>
                            </div>
                            <div className="column is-two-thirds">
                                <Markdown>{welcome}</Markdown>
                            </div>
                        </div>
                    </div>
                </div>


            </section>
        </>
    )
}

export default HomePage

